import { jsx as n } from "react/jsx-runtime";
import { Formik as A } from "formik";
import { isFunction as E } from "lodash-es";
import { useMemo as v } from "react";
import { S as h } from "../../errors-YTprc4A2.mjs";
import I from "./Wizard.js";
import { WizardProvider as M, initialState as q, useWizardContext as B } from "./context/context.js";
import { FormWrapper as G } from "./styled.js";
function H(i) {
  const { appStates: a, formValues: s } = B(), { renderStep: p, validationSchema: t, ...m } = i, d = E(t) ? t(a) : t;
  return /* @__PURE__ */ n(A, { validationSchema: d, ...m, children: (o) => /* @__PURE__ */ n(G, { children: p({ ...o, values: s }) }) });
}
function X({
  initialErrors: i,
  initialTouched: a,
  initialValues: s,
  onSubmit: p = () => {
  },
  onReset: t,
  initialAppStates: m = {},
  enableReinitialize: d,
  steps: o,
  breadCrumbs: x,
  opacityBetweenLoading: W,
  initialStepId: c,
  isHashEnabled: y,
  isStepperEnabed: f,
  showHeader: z,
  showFooter: F,
  storage: g,
  validationSchema: C,
  onWindowClose: N,
  headerProps: P,
  scrollOnSubmitError: k,
  scrollOptions: D,
  isStepperEnabled: V
}) {
  const [u, $] = v(() => {
    const r = {}, S = {};
    return o.map(({ Component: j, ...e }) => {
      if (r[e.id])
        throw new h(`A given step with id ${e.id} has already been declared`);
      S[e.id] = j, r[e.id] = e;
    }), [r, S];
  }, [o]);
  if (!c || !u[c])
    throw new h(
      "initialStep prop was not provided or was not found in the array of steps"
    );
  const l = v(() => o.findIndex((r) => !r.stepName), [o]);
  if (f && l !== -1)
    throw new h(
      `isStepperEnabed prop was set to "true" however step '${l + 1}' in the array is missing its stepName property`
    );
  const w = {
    initialValues: s,
    initialErrors: i,
    initialTouched: a,
    enableReinitialize: d,
    validationSchema: C,
    onReset: t
  }, b = {
    isHashEnabled: y,
    isStepperEnabed: f,
    breadCrumbs: x,
    stepsComponents: $,
    showHeader: z,
    showFooter: F,
    storage: g,
    opacityBetweenLoading: W,
    onWindowClose: N,
    headerProps: P,
    scrollOnSubmitError: k,
    isStepperEnabled: V ?? f,
    scrollOptions: D
  };
  return /* @__PURE__ */ n(
    M,
    {
      ...q(w),
      appStates: m,
      steps: u,
      currentStepId: c,
      children: /* @__PURE__ */ n(I, { ...b, children: ({ renderStep: r }) => /* @__PURE__ */ n(H, { ...w, onSubmit: p, renderStep: r }) })
    }
  );
}
export {
  X as default
};
